<template>
  <span>
    <i
      :class="stockIndicatorClasses(availability)"
      class="me-1"
      :data-bs-toggle="(availability === 'risky') ? 'tooltip' : ''"
      data-bs-placement="left"
      :data-bs-title="(availability === 'risky') ? $t('StockIndicator.risky') : '' "
    />
  </span>
</template>

<script>
import messages from 'locales/StockIndicator';

export default {
  props: {
    availability: String,
  },
  methods: {
    stockIndicatorClasses(availability) {
      switch (availability) {
        case 'available':
          return 'fas fa-check-circle text-success';
        case 'unavailable':
          return 'fas fa-times-circle text-danger';
        case 'risky':
          return 'fas fa-exclamation-circle text-warning';
        default:
          return '';
      }
    },
  },
  i18n: { messages },
};
</script>

<style lang="scss" scoped>

</style>
